export const STATS_DOMAIN = 'app/modules/Stats/STATS_DOMAIN';
export const FETCH_STATS = 'app/modules/Stats/FETCH_STATS';
export const FETCH_INSPECTION_STATS = 'app/modules/Stats/FETCH_INSPECTION_STATS';